const StepperButtonMinus = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <circle cx={16} cy={16} r={16} fill="currentColor" />
    <path className="st0" d="M20.5 15v1.5H11V15h9.5z" fill="#fff" />
  </svg>
)

export default StepperButtonMinus
